/**
 * True only for multi-day tournament type "Days" / "Day" — not "One-Day" (single-day cricket).
 * Normalizes hyphens/spaces then compares to whole-type tokens.
 */

export function isDaysMatchType(value) {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');
  return normalized === 'day' || normalized === 'days';
}

/** Resolves 1-based feedback day — same field order as API normalizeFeedbackDay, plus legacy `day`. */
export function resolveFeedbackDayNumber(item) {
  const day = Number(item?.feedbackDay ?? item?.matchDay ?? item?.dayNumber ?? item?.day);
  return Number.isFinite(day) && day >= 1 ? day : null;
}
